const COOKIE_NAME = "skien_attr_v1";
const TTL_DAYS = 14;

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();

  document.cookie =
    `${name}=${encodeURIComponent(value)}; ` +
    `expires=${expires}; path=/; SameSite=Lax; Secure`;
}

function getCookie(name) {
  const decoded = document.cookie
    .split("; ")
    .find((row) => row.startsWith(name + "="));

  if (!decoded) return null;

  const value = decoded.split("=").slice(1).join("=");
  return decodeURIComponent(value);
}

export function captureAttributionFromUrl() {
  if (typeof window === "undefined") return null;

  const sp = new URLSearchParams(window.location.search);

  const attribution = {
    utm_source: sp.get("utm_source") || "",
    utm_medium: sp.get("utm_medium") || "",
    utm_campaign: sp.get("utm_campaign") || "",
    first_seen: Date.now(),
  };

  const hasAnyUtm =
    attribution.utm_source ||
    attribution.utm_medium ||
    attribution.utm_campaign

  // Only store if we actually received UTMs
  if (!hasAnyUtm) return null;

  setCookie(COOKIE_NAME, JSON.stringify(attribution), TTL_DAYS);

  // Optional: push a capture event (useful for debugging in GTM Preview)
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "attribution_captured",
    ...attribution,
  });

  return attribution;
}

export function getAttribution() {
  if (typeof window === "undefined") return null;

  const raw = getCookie(COOKIE_NAME);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);
    return parsed;
  } catch {
    return null;
  }
}
